import { addDays, endOfWeek, startOfWeek } from 'date-fns';

export const getDefaultDates = () => {
  const today = new Date();
  // Add 8 days to today to ensure IB availability
  const startDate = addDays(today, 8);

  // Find the next weekend after startDate
  const nextWeekendStart = startOfWeek(startDate, { weekStartsOn: 6 }); // Saturday
  const nextWeekendEnd = endOfWeek(startDate, { weekStartsOn: 6 }); // Sunday

  // If startDate is already past this weekend, move to next weekend
  const finalStartDate =
    startDate > nextWeekendStart ? addDays(nextWeekendStart, 7) : nextWeekendStart;

  const finalEndDate = startDate > nextWeekendStart ? addDays(nextWeekendEnd, 7) : nextWeekendEnd;

  return {
    from: finalStartDate,
    to: finalEndDate,
  };
};
